export default {"src":"/_next/static/media/icon-portfolio.6a6fbc8b.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};